import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from "./Sidebar.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { Dashboard, DashboardActive, DocumentActive, DropDown, DropUp, Document, Admin, AdminActive, ProductActive, Product, Sample, SampleActive, Reports, ReportsActive, Appearance, AppearanceActive, NotificationsActive, Account, AccountActive, Notifications, Email } from '../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationCount } from '../../redux/notification/notification';
import api from '../../utils/api';
import logo from './logo.png';


// Purple count pill, same look as the Notifications badge; hidden when there is nothing unread
const SectionBadge = ({ count }) =>
  count > 0 ? (
    <span style={{ background: '#512DA8', color: '#fff', borderRadius: '10px', fontSize: '11px', fontWeight: 600, lineHeight: 1, minWidth: '20px', height: '20px', padding: '0 6px', boxSizing: 'border-box', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      {count > 99 ? '99+' : count}
    </span>
  ) : null;

const Sidebar = ({ activeMaster, toggleMaster }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [path, setPath] = useState('');
  const [subpath, setSubpath] = useState('');
  const pathname = location.pathname.split('/')[1];
  const subpathname = location.pathname.split('/')[2];
  const loc = location.pathname
  const { user } = useSelector((state) => state.user);
  const { notificationCountData } = useSelector((state) => state.notification);

  // Unread notifications per sidebar section ({ bom: 3, wizard: 1, ... }); refreshed whenever the
  // overall unread count changes (new notification over the socket, or marked as read)
  const [sectionCounts, setSectionCounts] = useState({});
  useEffect(() => {
    let cancelled = false;
    api
      .getUnreadCountBySection()
      .then((res) => {
        if (!cancelled) setSectionCounts(res?.data?.data || {});
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [notificationCountData]);

  // Opening a section (e.g. any BOM page) marks that section's notifications as read,
  // then the overall count refreshes, which refreshes these section counts too
  const dispatch = useDispatch();
  const BADGE_SECTIONS = ['bom', 'excess', 'schedule', 'wizard', 'users', 'orders', 'sample'];
  useEffect(() => {
    if (!BADGE_SECTIONS.includes(pathname) || !(sectionCounts[pathname] > 0)) return;
    api
      .markReadBySection(pathname)
      .then(() => {
        setSectionCounts((prev) => ({ ...prev, [pathname]: 0 }));
        dispatch(getNotificationCount());
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, sectionCounts]);

  useEffect(() => {
    setPath(pathname)
    setSubpath(subpathname)
  }, [pathname, subpathname])



  const isActive = /^(\/master\/(categories|addCategory|editCategory|viewcategory\/\d+))$/.test(location.pathname);
  const issubActive = /^(\/master\/(subcategories|addSubCategory|editSubCategory|viewSubcategory\/\d+))$/.test(location.pathname);
  const isLevel3Active = /^(\/master\/(level|addLevel|editLevel|viewLevel\/\d+))$/.test(location.pathname);
  const isAtributeActive = /^(\/master\/(variants|addVariants|editVariants|viewVariants\/\d+))$/.test(location.pathname);
  const isManufacturerActive = /^(\/master\/(manufacturers|addManufacturer|editManufacturers|viewManufacturers\/\d+))$/.test(location.pathname);

  const isproductActive = /^(\/products\/(products|allProduct|addProduct|customerDetails\/\d+))$/.test(location.pathname);

  const isBomModActive = loc.startsWith('/bom/bomEnquiresDetails') || loc.startsWith('/bom/bomQuote') || loc.startsWith('/bom/bomEnquires')
  const isBomOrderActive = loc.startsWith('/bom/BomOrderDetails') || loc.startsWith('/bom/bomOrders')
  const isVendorBomOrderActive = loc.startsWith('/bom/VendorBomOrders') || loc.startsWith('/bom/VendorBomOrderDetails')
  const isVendorWizardOrderActive = loc.startsWith('/wizard/VendorWizardOrders') || loc.startsWith('/wizard/VendorWizardOrderDetails')
  const isWizardEnqActive = loc.startsWith('/wizard/wizardEnquires') || loc.startsWith('/wizard/wizardEnquiresDetails') || loc.startsWith('/wizard/wizardQuote')
  const iswizardorderactive = loc.startsWith('/wizard/wizardOrders') || loc.startsWith('/wizard/wizardOrderDetails')

  const isExcessEnqActive = loc.startsWith('/excess/excessEnquires') || loc.startsWith('/excess/excessEnquiresDetails') || loc.startsWith('/excess/excessQuote')
  const isExcessorderactive = loc.startsWith('/excess/excessOrders') || loc.startsWith('/excess/excessOrderDetails')
  const isVendorExcessorderactive = loc.startsWith('/excess/vendorExcessInventory') || loc.startsWith('/excess/VendorExcessDetails')


  const isScheduleEnqactive = loc.startsWith('/schedule/scheduleEnquires') || loc.startsWith('/excess/VendorExcessDetails')
  const isScheduleOrderactive = loc.startsWith('/schedule/scheduleOrders') || loc.startsWith('/schedule/scheduleOrderDetails')

  const isCustomerActive = loc.startsWith('/users/customers') || loc.startsWith('/users/addCustomer') || loc.startsWith('/users/customerDetails') || loc.startsWith('/users/editCustomer')
  const isvendorActive = loc.startsWith('/users/vendors') || loc.startsWith('/users/addVendor') || loc.startsWith('/users/vendorDetails') || loc.startsWith('/users/editVendor')

  return (

    <div className={styles.sideMenuBar}>
      <div className={styles.logomain} onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <div className={styles.logo}>
          <img 
            src={logo} 
            alt="Electrowiz" 
            style={{ maxHeight: '40px', maxWidth: '195px', width: '100%', objectFit: 'contain' }}
          />
        </div>
      </div>

      <section className={styles.left}>
        <div onClick={() => navigate('/')} className={path === '' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {
              path === "" ?
                <DashboardActive />
                :
                <Dashboard />
            }
            <div className={styles.dashboardText}>
              Dashboard
            </div>
          </div>
        </div>


        <div onClick={() => navigate('/master/categories')} className={path === 'master' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'master' ?
              (
                <DocumentActive />
              )
              :
              <Document />
            }
            <p className={styles.dashboardText}>
              Master
            </p>
          </div>
          {path === 'master' ? (
            <div>
              <DropDown />
            </div>
          ) : <DropUp />}
        </div>
        {
          path === 'master' ?
            <div className={styles.subpaths}>
              <div onClick={() => navigate('/master/categories')} className={isActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical} style={{ top: "-5px", height: 30 }}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Categories
              </div>
              <div onClick={() => navigate('/master/subcategories')} className={issubActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Subcategories
              </div>
              <div onClick={() => navigate('/master/level')} className={isLevel3Active ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Level 3
              </div>
              <div onClick={() => navigate('/master/variants')} className={isAtributeActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Attributes
              </div>
              <div onClick={() => navigate('/master/manufacturers')} className={isManufacturerActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Manufacturer
              </div>
            </div> : ''
        }


        <div onClick={() => navigate('/bom/bomEnquires')} className={path === 'bom' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'bom' ?
              (
                <ProductActive />
              )
              :
              <Product />
            }
            <p className={styles.dashboardText}>
              BOM
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <SectionBadge count={sectionCounts.bom} />
            {path === 'bom' ? (
              <div>
                <DropDown />
              </div>
            ) : <DropUp />}
          </div>
        </div>
        {
          path === 'bom' ?
            <div className={styles.subpaths}>
              <div onClick={() => navigate('/bom/bomEnquires')} className={isBomModActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical} style={{ top: "-5px", height: 30 }}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Enquiries
              </div>
              <div onClick={() => navigate('/bom/bomOrders')} className={isBomOrderActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Orders
              </div>
              <div onClick={() => navigate('/bom/VendorBomOrders')} className={isVendorBomOrderActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Vendor Orders
              </div>
            </div> : ''
        }


        <div onClick={() => navigate('/excess/excessEnquires')} className={path === 'excess' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'excess' ?
              (
                <ProductActive />
              )
              :
              <Product />
            }
            <p className={styles.dashboardText}>
              Excess Inventory
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <SectionBadge count={sectionCounts.excess} />
            {path === 'excess' ? (
              <div>
                <DropDown />
              </div>
            ) : <DropUp />}
          </div>
        </div>
        {
          path === 'excess' ?
            <div className={styles.subpaths}>
              <div onClick={() => navigate('/excess/excessEnquires')} className={isExcessEnqActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical} style={{ top: "-5px", height: 30 }}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Enquiries
              </div>
              <div onClick={() => navigate('/excess/excessOrders')} className={isExcessorderactive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Orders
              </div>
              <div onClick={() => navigate('/excess/vendorExcessInventory')} className={isVendorExcessorderactive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Vendor
              </div>
            </div> : ''
        }



        <div onClick={() => navigate('/schedule/scheduleEnquires')} className={path === 'schedule' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'scheduled' ?
              (
                <ProductActive />
              )
              :
              <Product />
            }
            <p className={styles.dashboardText}>
              Scheduled
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <SectionBadge count={sectionCounts.schedule} />
            {path === 'scheduled' ? (
              <div>
                <DropDown />
              </div>
            ) : <DropUp />}
          </div>
        </div>
        {
          path === 'schedule' ?
            <div className={styles.subpaths}>
              <div onClick={() => navigate('/schedule/scheduleEnquires')} className={isScheduleEnqactive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical} style={{ top: "-5px", height: 30 }}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Enquiries
              </div>
              <div onClick={() => navigate('/schedule/scheduleOrders')} className={isScheduleOrderactive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Orders
              </div>
            </div> : ''
        }



        <div onClick={() => navigate('/wizard/wizardEnquires')} className={path === 'wizard' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'wizard' ?
              (
                <ProductActive />
              )
              :
              <Product />
            }
            <p className={styles.dashboardText}>
              Wizard
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <SectionBadge count={sectionCounts.wizard} />
            {path === 'wizard' ? (
              <div>
                <DropDown />
              </div>
            ) : <DropUp />}
          </div>
        </div>
        {
          path === 'wizard' ?
            <div className={styles.subpaths}>
              <div onClick={() => navigate('/wizard/wizardEnquires')} className={isWizardEnqActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical} style={{ top: "-5px", height: 30 }}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Enquiries
              </div>
              <div onClick={() => navigate('/wizard/wizardOrders')} className={iswizardorderactive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Orders
              </div>
              <div onClick={() => navigate('/wizard/VendorWizardOrders')} className={isVendorWizardOrderActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Vendor Orders
              </div>
            </div> : ''
        }


        <div onClick={() => navigate('/users/customers')} className={path === 'users' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'users' ?
              (
                <AdminActive />
              )
              :
              <Admin />
            }
            <p className={styles.dashboardText}>
              Users
            </p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <SectionBadge count={sectionCounts.users} />
            {path === 'users' ? (
              <div>
                <DropDown />
              </div>
            ) : <DropUp />}
          </div>
        </div>
        {
          path === 'users' ?
            <div className={styles.subpaths}>
              <div onClick={() => navigate('/users/customers')} className={isCustomerActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical} style={{ top: "-5px", height: 30 }}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Customers
              </div>
              <div onClick={() => navigate('/users/vendors')} className={isvendorActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical}></span>
                  <span className={styles.horizontal}></span>
                </div>
                Vendors
              </div>
            </div> : ''
        }

        <div onClick={() => navigate('/products/allProduct')} className={path === 'products' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'products' ?
              (
                <ProductActive />
              )
              :
              <Product />
            }
            <p className={styles.dashboardText}>
              Products
            </p>
          </div>
          {path === 'products' ? (
            <div>
              <DropDown />
            </div>
          ) : <DropUp />}
        </div>
        {
          path === 'products' ?
            <div className={styles.subpaths}>
              <div onClick={() => navigate('/products/allProduct')} className={isproductActive ? styles.submenu : styles.menuText}>
                <div className={styles.lines}>
                  <span className={styles.vertical} style={{ top: "-5px", height: 30 }}></span>
                  <span className={styles.horizontal}></span>
                </div>
                All Products
              </div>

            </div> : ''
        }

        {user?.type == "SUPERADMIN" &&
          <div onClick={() => navigate('/admin/allAdminUsers')} className={path === 'admin' ? `${styles.width} ${styles.active}` : styles.width}>
            <div>
              {path === 'admin' ?
                (
                  <AdminActive />
                )
                :
                <Admin />
              }
              <p className={styles.dashboardText}>
                Admin
              </p>
            </div>
          </div>
        }

        <div onClick={() => navigate('/asset/allAsset')} className={path === 'asset' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'asset' ?
              (
                <AdminActive />
              )
              :
              <Admin />
            }
            <p className={styles.dashboardText}>
              Assets
            </p>
          </div>
        </div>
        <div onClick={() => navigate('/orders/allOrders')} className={path === 'orders' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'orders' ?
              (
                <ProductActive />
              )
              :
              <Product />
            }
            <p className={styles.dashboardText}>
              Cart Orders
            </p>
          </div>
          <SectionBadge count={sectionCounts.orders} />
        </div>


        <div onClick={() => navigate('/sample/sampleRequests')} className={path === 'sample' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'sample' ?
              (
                <SampleActive />
              )
              :
              <Sample />
            }
            <p className={styles.dashboardText}>
              Sample request
            </p>
          </div>
          <SectionBadge count={sectionCounts.sample} />
        </div>

        {/* <div onClick={() => navigate('/reports/allOrders')} className={path === 'reports' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'reports' ?
              (
                <ReportsActive />
              )
              :
              <Reports />
            }
            <p className={styles.dashboardText}>
              Reports
            </p>
          </div>
        </div> */}

        <div onClick={() => navigate('/appearance/appearancePage')} className={path === 'appearance' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'appearance' ?
              (
                <AppearanceActive />
              )
              :
              <Appearance />
            }
            <p className={styles.dashboardText}>
              Appearance
            </p>
          </div>
        </div>

        <div onClick={() => navigate('/notifications')} className={path === 'notifications' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'notifications' ?
              (
                <NotificationsActive />
              )
              :
              <Notifications />
            }
            <p className={styles.dashboardText}>
              Notifications
            </p>
          </div>
          {notificationCountData > 0 && (
            <span style={{ background: '#512DA8', color: '#fff', borderRadius: '10px', fontSize: '11px', fontWeight: 600, lineHeight: 1, minWidth: '20px', height: '20px', padding: '0 6px', boxSizing: 'border-box', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
              {notificationCountData > 99 ? '99+' : notificationCountData}
            </span>
          )}
        </div>

        <div onClick={() => navigate('/accountSetting')} className={path === 'accountSetting' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            {path === 'account' ?
              (
                <AccountActive />
              )
              :
              <Account />
            }
            <p className={styles.dashboardText}>
              Account Setting
            </p>
          </div>
        </div>

        <div onClick={() => navigate('/backup')} className={path === 'backup' ? `${styles.width} ${styles.active}` : styles.width}>
          <div>
            <Document />
            <p className={styles.dashboardText}>
              Backup
            </p>
          </div>
        </div>

        {user?.type == "SUPERADMIN" &&
          <div onClick={() => navigate('/email')} className={path === 'email' ? `${styles.width} ${styles.active}` : styles.width}>
            <div>
              <Email />
              <p className={styles.dashboardText}>
                Email
              </p>
            </div>
          </div>
        }
      </section>
    </div>
  );
};

export default Sidebar;
